module.exports = __webpack_public_path__ + "img/3.e5a060f7.jpg";